/* eslint-disable @typescript-eslint/no-explicit-any */
import Link from 'next/link'
interface navType {
  active: number
}
const NavigatorPost = ({ active }: navType) => {
  const tabList = [
    {
      id: 1,
      label: 'Tin tức',
      path: '/post',
      description: '',
    },
    {
      id: 2,
      label: 'Khuyến mãi',
      path: '/hot-deal',
      description: '',
    },

    {
      id: 3,
      label: 'Chính sách',
      path: '/policy',
      description: '',
    },
  ]

  return (
    <div className='mb-2 py-2 bg-white w-full flex items-center overflow-x-auto scrollBarCS justify-between container'>
      {tabList &&
        tabList.map((e, i) => {
          return (
            <Link
              href={e.path || '/'}
              key={i}
              className={'mr-2 cursor-pointer outline-none'}
            >
              <div
                className={`head-item px-3 transition flex items-center h-8 w-max overflow-hidden ${
                  active == i ? 'border-b-[3px] border-redPico  ' : ''
                }`}
              >
                <span
                  className={`flex-1${
                    active == i ? 'font-bold text-redPico' : ''
                  }`}
                >
                  {e.label}
                </span>
              </div>
            </Link>
          )
        })}
    </div>
  )
}

export default NavigatorPost
